// Tassi indicativi (EUR per 1 unità di valuta) — solo stima per confronto rapido
export const RATES_EUR = { EUR: 1, CHF: 1.06, GBP: 1.17, USD: 0.92 };

// Valuta di riferimento del cliente (piattaforma italiana)
export const CLIENT_CURRENCY = "EUR";

export function eurEquivalent(amount, code) {
    if (!code || code === CLIENT_CURRENCY) return null;
    const rate = RATES_EUR[code];
    if (!rate || amount == null || isNaN(amount)) return null;
    return Math.round(amount * rate);
}
